import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { auth, messaging } from "../firebase";
import { DEFAULT_FIREBASE_PASSWORD } from "./common.data";
import ApiService from "./Api";
import { UPDATE_USER_PROFILE } from "./Endpoint";
import { getToken } from "firebase/messaging";

export const fireBaseEmailLogin = async (email, api_key, user_id) => {
  if (!email) {
    console.log("Provide Email");
    return;
  }

  let password = DEFAULT_FIREBASE_PASSWORD;

  try {
    // Attempt to sign in
    const checkUser = await signInWithEmailAndPassword(auth, email, password);

    // User successfully logged in
    // console.log("User logged in successfully", checkUser);

    // Proceed to update user profile if needed
    const userCredential = checkUser;
    const user = userCredential.user;
    await ApiService.post(
      `${UPDATE_USER_PROFILE}?api_key=${api_key}&user_id=${user_id}`,
      {
        fire_id: user?.uid,
        fire_password: password,
      }
    );    
    sessionStorage.setItem("fire_id", user?.uid);
  } catch (error) {
    const errorCode = error.code;
    const errorMessage = error.message;

    if (errorCode === "auth/user-not-found") {
      // User does not exist, so let's create a new user
      console.log("User not found, proceeding to registration...");

      try {
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          email,
          password
        );
        const user = userCredential.user;
        // console.log("New user created:", user);

        // update user profile after registration
        await ApiService.post(
          `${UPDATE_USER_PROFILE}?api_key=${api_key}&user_id=${user_id}`,
          {
            fire_id: user?.uid,
            fire_password: password,
          }
        );
        sessionStorage.setItem("fire_id", user?.uid);
      } catch (registrationError) {
        const registrationErrorCode = registrationError.code;
        const registrationErrorMessage = registrationError.message;
        console.log(
          "Registration errorCode:",
          registrationErrorCode,
          "errorMessage:",
          registrationErrorMessage
        );
      }
    } else {
      // Handle other login errors (e.g., wrong password, network issues)
      console.log("Error during login:", errorCode, errorMessage);
    }
  }
};

export const firebaseEmailRegister = async (email) => {
  if (!email) {
    console.log("Provide Email");
    return;
  }

  let password = DEFAULT_FIREBASE_PASSWORD;

  let value = {
    fire_id: "",
    fire_password: password,
  };

  try {
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );
    const user = userCredential.user;
    value.fire_id = user?.uid;
    return value;
  } catch (error) {
    const errorCode = error.code;
    const errorMessage = error.message;
    console.log("Error during login:", errorCode, errorMessage);
    return value;
  }
};

export const firebaseLogout = () => {
  if(auth?.currentUser){
    signOut(auth)
    .then(() => {
      // Sign-out successful.
    })
    .catch((error) => {
      // An error happened.
    });
  }
};

export const getPushNotificationToken = async () => {
  const apikey = sessionStorage.getItem("key");
  const userid = sessionStorage.getItem("userid");
  try {
    const currentToken = await getToken(messaging, {
      vapidKey: "BOr1PaT7wVjteD5oUowPIzSCBbj2T06TQ7nJnAevrXo7AaUdoDnIghd3mS09PbmF3gsvKGADBGxoZ5nCLUAE64M",
    });

    if (currentToken) {
      // console.log("FCM Token:", currentToken);
      // You can send this token to your backend to store it for later use
      await ApiService.post(
        `${UPDATE_USER_PROFILE}?api_key=${apikey}&user_id=${userid}`,
        {
          u_device_token:currentToken,
          u_device_type:'Browser'
        }
      );
    } else {
      console.log(
        "No registration token available. Request permission to generate one."
      );
      requestNotificationPermission()
    }
  } catch (err) {
    console.error("An error occurred while retrieving the token.", err);
  }
};

// Ask for Notification Permission
export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      // console.log("Notification permission granted.");
      // Now get the token
      await getPushNotificationToken();
    } else {
      console.log("Notification permission denied.");
    }
  } catch (err) {
    console.error("Error during permission request:", err);
  }
};